export default {
	NONE: 'none',
	COVER_PARENT: 'parent',
	COVER_PAGE: 'page',
};
